import { Card, CardContent, Typography, CardMedia } from "@mui/material"

// PROTECTED ANIMAL
export default function ProtectedAnimal({ animalName, animalImageName }: ProtectedAnimalProps) {
    return (
        <Card
            sx={{
                '&:last-child': {
                    mb: 0
                },
                px: 1,
                py: .85,
                mb: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
            }}
        >
            <CardContent>
                <Typography component="div" variant="h6">
                    {animalName}
                </Typography>
            </CardContent>

            <CardMedia
                component="img"
                sx={{ width: 85 }}
                image={new URL(`../assets/protected_animals/${animalImageName}`, import.meta.url).href}
                alt={animalName}
            />
        </Card>
    )
}
